export default __webpack_public_path__ + "static/media/bugz.abb1a214.md";